export default {
    UNPIN_NODE: "Вернуть в группу"
};
